import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import * as React from 'react';
import classNames from 'classnames';
import { useState, useEffect } from 'react';
import KeyCode from "rc-util/es/KeyCode";
import Menu, { MenuItem, SubMenu } from 'rc-menu';
import Dropdown from 'rc-dropdown';
import AddButton from './AddButton';

function OperationNode(_ref, ref) {
  var prefixCls = _ref.prefixCls,
      activeKey = _ref.activeKey,
      id = _ref.id,
      tabs = _ref.tabs,
      locale = _ref.locale,
      mobile = _ref.mobile,
      _ref$moreIcon = _ref.moreIcon,
      moreIcon = _ref$moreIcon === void 0 ? 'More' : _ref$moreIcon,
      moreTransitionName = _ref.moreTransitionName,
      style = _ref.style,
      className = _ref.className,
      editable = _ref.editable,
      tabBarGutter = _ref.tabBarGutter,
      rtl = _ref.rtl,
      tabPosition = _ref.tabPosition,
      operationNodeDropdownProps = _ref.operationNodeDropdownProps,
      renderOverlay = _ref.renderOverlay,
      onTabClick = _ref.onTabClick,
      getPopupContainer = _ref.getPopupContainer;

  // ======================== Dropdown ========================
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  var _useState3 = useState(activeKey),
      _useState4 = _slicedToArray(_useState3, 2),
      selectedKey = _useState4[0],
      setSelectedKey = _useState4[1];

  useEffect(function () {
    setSelectedKey(activeKey);
  }, [activeKey]);
  var popupId = "".concat(id, "-more-popup");
  var dropdownPrefix = "".concat(prefixCls, "-dropdown");
  var selectedItemId = selectedKey !== null ? "".concat(popupId, "-").concat(selectedKey) : null;
  var dropdownAriaLabel = locale ? locale.dropdownAriaLabel : undefined;

  var onOverlayClick = function onOverlayClick(_ref2) {
    var key = _ref2.key,
        domEvent = _ref2.domEvent;
    onTabClick(key, domEvent);
    setOpen(false);
  };

  var rawMenu = /*#__PURE__*/React.createElement(Menu, {
    onClick: onOverlayClick,
    id: popupId,
    tabIndex: -1,
    role: "listbox",
    "aria-activedescendant": selectedItemId,
    selectedKeys: [selectedKey],
    "aria-label": dropdownAriaLabel !== undefined ? dropdownAriaLabel : 'expanded dropdown'
  }, tabs.map(function (tab) {
    return /*#__PURE__*/React.createElement(MenuItem, {
      key: tab.key,
      id: "".concat(popupId, "-").concat(tab.key),
      role: "option",
      "aria-controls": id && "".concat(id, "-panel-").concat(tab.key),
      disabled: tab.disabled
    }, tab.tab);
  }));
  var menu = renderOverlay ? renderOverlay({
    tabs: tabs,
    selectedKey: selectedKey,
    onOverlayClick: onOverlayClick
  }) : rawMenu;

  function selectOffset(offset) {
    var enabledTabs = tabs.filter(function (tab) {
      return !tab.disabled;
    });
    var selectedIndex = enabledTabs.findIndex(function (tab) {
      return tab.key === selectedKey;
    }) || 0;
    var len = enabledTabs.length;

    for (var i = 0; i < len; i += 1) {
      selectedIndex = (selectedIndex + offset + len) % len;
      var tab = enabledTabs[selectedIndex];

      if (!tab.disabled) {
        setSelectedKey(tab.key);
        return;
      }
    }
  }

  function onKeyDown(e) {
    var which = e.which;

    if (!open) {
      if ([KeyCode.DOWN, KeyCode.SPACE, KeyCode.ENTER].includes(which)) {
        setOpen(true);
        e.preventDefault();
      }

      return;
    }

    switch (which) {
      case KeyCode.UP:
        selectOffset(-1);
        e.preventDefault();
        break;

      case KeyCode.DOWN:
        selectOffset(1);
        e.preventDefault();
        break;

      case KeyCode.ESC:
        setOpen(false);
        break;

      case KeyCode.SPACE:
      case KeyCode.ENTER:
        if (selectedKey !== null) onTabClick(selectedKey, e);
        break;
    }
  } // ========================= Effect =========================


  useEffect(function () {
    // We use query element here to avoid React strict warning
    var ele = document.getElementById(selectedItemId);

    if (ele && ele.scrollIntoView) {
      ele.scrollIntoView(false);
    }
  }, [selectedKey]); // useEffect(() => {
  //   if (!open) {
  //     setSelectedKey(null);
  //   }
  // }, [open]);
  // ========================= Render =========================

  var moreStyle = _defineProperty({}, rtl ? 'marginLeft' : 'marginRight', tabBarGutter);

  if (!tabs.length) {
    moreStyle.visibility = 'hidden';
    moreStyle.order = 1;
  }

  var overlayClassName = classNames(_defineProperty({}, "".concat(dropdownPrefix, "-rtl"), rtl));
  var moreButton = /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "".concat(prefixCls, "-nav-more"),
    style: moreStyle,
    tabIndex: -1,
    "aria-hidden": "true",
    "aria-haspopup": "listbox",
    "aria-controls": popupId,
    id: "".concat(id, "-more"),
    "aria-expanded": open,
    onKeyDown: onKeyDown
  }, moreIcon);

  var getVerticalMenu = function getVerticalMenu() {
    var rawVerticalMenu = /*#__PURE__*/React.createElement(Menu, {
      onClick: onOverlayClick,
      prefixCls: "".concat(prefixCls, "-menu"),
      id: popupId,
      tabIndex: -1,
      selectedKeys: [selectedKey],
      getPopupContainer: getPopupContainer
    }, /*#__PURE__*/React.createElement(SubMenu, {
      title: moreButton,
      key: "tabs-submenu"
    }, tabs.map(function (tab) {
      return /*#__PURE__*/React.createElement(MenuItem, {
        key: tab.key,
        id: "".concat(popupId, "-").concat(tab.key),
        role: "option",
        "aria-controls": id && "".concat(id, "-panel-").concat(tab.key),
        disabled: tab.disabled
      }, tab.tab);
    })));
    return renderOverlay ? renderOverlay({
      tabs: tabs,
      selectedKey: selectedKey,
      onOverlayClick: onOverlayClick
    }) : rawVerticalMenu;
  };

  var moreNode = mobile ? null : /*#__PURE__*/React.createElement(Dropdown, _extends({
    prefixCls: dropdownPrefix,
    overlay: menu,
    trigger: ['hover'],
    visible: open,
    transitionName: moreTransitionName,
    onVisibleChange: setOpen,
    overlayClassName: overlayClassName,
    mouseEnterDelay: 0.1,
    mouseLeaveDelay: 0.1
  }, operationNodeDropdownProps), moreButton);
  return /*#__PURE__*/React.createElement(React.Fragment, null, tabPosition === 'left' || tabPosition === 'right' ? /*#__PURE__*/React.createElement("div", {
    className: classNames("".concat(prefixCls, "-nav-operations"), className),
    ref: ref
  }, getVerticalMenu(), /*#__PURE__*/React.createElement(AddButton, {
    prefixCls: prefixCls,
    locale: locale,
    editable: editable
  })) : /*#__PURE__*/React.createElement("div", {
    className: classNames("".concat(prefixCls, "-nav-operations"), className),
    style: style,
    ref: ref
  }, moreNode, /*#__PURE__*/React.createElement(AddButton, {
    prefixCls: prefixCls,
    locale: locale,
    editable: editable
  })));
}

export default /*#__PURE__*/React.forwardRef(OperationNode);